import * as i0 from '@angular/core';
import { EventEmitter, Component, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, NgModule } from '@angular/core';
import * as i1 from '@niceltd/sol/translation';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
function ChipComponent_div_2_ng_template_1_Template(rf, ctx) {}
function ChipComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵtemplate(1, ChipComponent_div_2_ng_template_1_Template, 0, 0, "ng-template", 6);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.icon);
  }
}
function ChipComponent_span_3_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 10);
    i0.ɵɵlistener("dblclick", function ChipComponent_span_3_span_1_Template_span_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r8 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r8.setLabelEditable());
    })("keydown", function ChipComponent_span_3_span_1_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r9);
      const ctx_r10 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r10.onMainLabelKeydown($event));
    })("blur", function ChipComponent_span_3_span_1_Template_span_blur_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r11 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r11.onMainLabelBlur());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("contentEditable", ctx_r5.labelEditState);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r5.label, " ");
  }
}
function ChipComponent_span_3_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r6.label);
  }
}
function ChipComponent_span_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 7);
    i0.ɵɵtemplate(1, ChipComponent_span_3_span_1_Template, 2, 2, "span", 8)(2, ChipComponent_span_3_ng_template_2_Template, 1, 1, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r7 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.labelEditable)("ngIfElse", _r7);
  }
}
function ChipComponent_span_4_span_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r16 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "span", 14);
    i0.ɵɵlistener("dblclick", function ChipComponent_span_4_span_1_Template_span_dblclick_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r15 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r15.setSubLabelEditable());
    })("keydown", function ChipComponent_span_4_span_1_Template_span_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r16);
      const ctx_r17 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r17.onSubLabelKeydown($event));
    })("blur", function ChipComponent_span_4_span_1_Template_span_blur_0_listener() {
      i0.ɵɵrestoreView(_r16);
      const ctx_r18 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r18.onSubLabelBlur());
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("tabindex", -1)("contentEditable", ctx_r12.subLabelEditState);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r12.subLabel, " ");
  }
}
function ChipComponent_span_4_ng_template_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate(ctx_r13.subLabel);
  }
}
function ChipComponent_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 11);
    i0.ɵɵtemplate(1, ChipComponent_span_4_span_1_Template, 2, 3, "span", 12)(2, ChipComponent_span_4_ng_template_2_Template, 1, 1, "ng-template", null, 13, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r14 = i0.ɵɵreference(3);
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.subLabelEditable)("ngIfElse", _r14);
  }
}
function ChipComponent_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 15);
    i0.ɵɵlistener("click", function ChipComponent_button_5_Template_button_click_0_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r19 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r19.onClose($event));
    })("keydown", function ChipComponent_button_5_Template_button_keydown_0_listener($event) {
      i0.ɵɵrestoreView(_r20);
      const ctx_r21 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r21.onCloseButtonKeydown($event));
    })("focus", function ChipComponent_button_5_Template_button_focus_0_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r22 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r22.onCloseIconFocus());
    })("blur", function ChipComponent_button_5_Template_button_blur_0_listener() {
      i0.ɵɵrestoreView(_r20);
      const ctx_r23 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r23.onCloseIconBlur());
    });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(1, "svg", 16);
    i0.ɵɵelement(2, "path", 17);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵattribute("aria-label", ctx_r3.closeIconAriaLabel);
  }
}
let chipCount = 1;
/** Represents an event fired on an individual `sol-chip`. */
class ChipEvent {
  constructor(source) {
    this.chip = source;
  }
}
class ChipComponent {
  /**
   * sets id to chip
   */
  set id(id) {
    this._id = id;
  }
  get id() {
    if (!this._id) {
      return `sol-chip-${this._uniqueId}`;
    }
    return this._id;
  }
  /**
   * Describes whether the chip has clickable close icon or not
   */
  set allowClose(val) {
    this._allowClose = val;
    this.cdr.detectChanges();
    this.closeIcon = this.elementRef.nativeElement.querySelector('.close-icon');
  }
  get allowClose() {
    return this._allowClose;
  }
  constructor(translationService, elementRef, cdr, renderer) {
    this.translationService = translationService;
    this.elementRef = elementRef;
    this.cdr = cdr;
    this.renderer = renderer;
    this._allowClose = false;
    this.labelEditState = false;
    this.subLabelEditState = false;
    this._id = '';
    /**
     * Describes whether the `label` is editable or not
     */
    this.labelEditable = false;
    /**
     * Describes whether the `subLabel` is editable or not
     */
    this.subLabelEditable = false;
    /**
     * Indicates the `tabindex` property for the chip component
     */
    this.chipTabIndex = '0';
    /**
     * Indicates the `role` property for the chip component
     */
    this.chipRole = 'none';
    /**
     * Special variant used to describe the chip in error state
     */
    this.errorState = false;
    /**
     * Describes the variant of the chip
     */
    this.variant = 'basic';
    /**
     * Describes the chip size
     */
    this.size = 'medium';
    /**
     * Describes the label property of the chip
     */
    this.label = '';
    /**
     * Describes the sub label property of the chip
     */
    this.subLabel = '';
    /**
     * Describes the icon template reference
     */
    this.icon = null;
    this.closeIconAriaLabel = this.translationService.getTranslation('remove');
    /**
     * Emits when the close icon is clicked
     */
    this.closed = new EventEmitter();
    /**
     * Emits when the chip is clicked
     */
    this.chipClicked = new EventEmitter();
    /**
     * Emits when keydown event from the focussed chip close icon
     */
    this.closeButtonKeydown = new EventEmitter();
    /**
     * Emits when keydown event from the focussed chip
     */
    this.chipKeydown = new EventEmitter();
    /**
     * Emits when `label` property is changed
     */
    this.labelChanged = new EventEmitter();
    /**
     * Emits when `subLabel` property is changed
     */
    this.subLabelChanged = new EventEmitter();
    this._uniqueId = chipCount++;
  }
  ngAfterViewInit() {
    this.chipElement = this.elementRef.nativeElement.querySelector('.sol-chip');
  }
  getClass() {
    return [this.variant, this.size];
  }
  onCloseIconFocus() {
    this.renderer.removeAttribute(this.closeIcon, 'aria-hidden');
  }
  onCloseIconBlur() {
    this.renderer.setAttribute(this.closeIcon, 'aria-hidden', 'true');
  }
  /**
   * Handles chip close icon click and enter or spacebar keydown
   */
  onClose(event) {
    // stopping propagation so that it does not trigger chip click event
    event.stopPropagation();
    this.closed.emit(new ChipEvent(this));
  }
  /**
   * Handles chip keydown event
   */
  onChipKeydown(event) {
    if (event.code === 'Enter') {
      this.onChipEnter(event);
    } else if (event.code === 'ArrowRight') {
      // focus close button if it exists
      if (this.allowClose) this.closeIcon.focus();
    }
    this.chipKeydown.emit(event);
  }
  /**
   * Handles chip click event
   */
  onChipClick(event) {
    this.chipClicked.emit(event);
  }
  /**
   * Handles enter keydown event
   */
  onChipEnter(event) {
    if (this.labelEditable) {
      this.setLabelEditable();
      event.preventDefault();
    } else if (this.subLabelEditable) {
      this.setSubLabelEditable();
      event.preventDefault();
    }
  }
  /**
   * Sets the `label` to edit mode
   */
  setLabelEditable() {
    this.labelEditState = true;
    this.cdr.detectChanges();
    this.setCaret(this.getEditableLabelElement());
  }
  /**
   * Sets the `subLabel` to edit mode
   */
  setSubLabelEditable() {
    this.subLabelEditState = true;
    this.cdr.detectChanges();
    this.setCaret(this.getEditableSubLabelElement());
  }
  getEditableLabelElement() {
    return this.elementRef.nativeElement.querySelector('.label-edit-mode');
  }
  getEditableSubLabelElement() {
    return this.elementRef.nativeElement.querySelector('.sub-label-edit-mode');
  }
  /**
   * Handles `label` keydown event
   */
  onMainLabelKeydown(event) {
    event.stopPropagation();
    if (event.code === 'Enter') {
      event.preventDefault();
      if (this.subLabelEditable) {
        this.setSubLabelEditable();
      } else {
        this.chipElement.focus();
      }
    }
  }
  /**
   * Handles `subLabel` keydown event
   */
  onSubLabelKeydown(event) {
    event.stopPropagation();
    if (event.code === 'Enter') {
      event.preventDefault();
      this.chipElement.focus();
    }
  }
  /**
   * Handles `label` blur event
   * Here we update the label and update the edit state
   */
  onMainLabelBlur() {
    if (this.labelEditState) {
      this.labelEditState = false;
      const mainLabel = this.getEditableLabelElement();
      const oldLabel = this.label;
      this.label = mainLabel.textContent.trim();
      if (oldLabel !== this.label) {
        this.labelChanged.emit(this.label);
      }
    }
  }
  /**
   * Handles `subLabel` blur event
   * Here we update the label and update the edit state
   */
  onSubLabelBlur() {
    if (this.subLabelEditState) {
      this.subLabelEditState = false;
      const subLabel = this.getEditableSubLabelElement();
      const oldSubLabel = this.subLabel;
      this.subLabel = subLabel.textContent.trim();
      if (oldSubLabel !== this.subLabel) {
        this.subLabelChanged.emit(this.label);
      }
    }
  }
  /**
   * Sets the cursor to the required HTML element
   */
  setCaret(element) {
    const range = document.createRange();
    const sel = window.getSelection();
    const hasContent = Boolean(element.textContent);
    if (hasContent) {
      range.setStart(element, 1);
      range.collapse(true);
    } else {
      range.setStart(element, 0);
      range.setEnd(element, 0);
    }
    range.collapse(true);
    sel?.removeAllRanges();
    sel?.addRange(range);
  }
  /**
   * Handles close icon keydown event
   */
  onCloseButtonKeydown(event) {
    event.stopPropagation();
    if (event.code === 'ArrowLeft') {
      this.chipElement.focus();
    }
    this.closeButtonKeydown.emit(event);
  }
  static {
    this.ɵfac = function ChipComponent_Factory(t) {
      return new (t || ChipComponent)(i0.ɵɵdirectiveInject(i1.TranslationService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.ChangeDetectorRef), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: ChipComponent,
      selectors: [["sol-chip"]],
      inputs: {
        id: "id",
        allowClose: "allowClose",
        labelEditable: "labelEditable",
        subLabelEditable: "subLabelEditable",
        chipTabIndex: "chipTabIndex",
        chipRole: "chipRole",
        errorState: "errorState",
        variant: "variant",
        size: "size",
        label: "label",
        subLabel: "subLabel",
        icon: "icon",
        closeIconAriaLabel: "closeIconAriaLabel"
      },
      outputs: {
        closed: "closed",
        chipClicked: "chipClicked",
        closeButtonKeydown: "closeButtonKeydown",
        chipKeydown: "chipKeydown",
        labelChanged: "labelChanged",
        subLabelChanged: "subLabelChanged"
      },
      decls: 6,
      vars: 12,
      consts: [[1, "sol-chip", 3, "id", "tabindex", "keydown", "click"], ["class", "icon", 4, "ngIf"], ["class", "main-label chip-text-content", 4, "ngIf"], ["class", "sub-label chip-text-content", 4, "ngIf"], ["class", "close-icon", "tabindex", "-1", "aria-hidden", "true", 3, "click", "keydown", "focus", "blur", 4, "ngIf"], [1, "icon"], [3, "ngTemplateOutlet"], [1, "main-label", "chip-text-content"], ["tabindex", "-1", "class", "label-edit-mode chip-text-editable", 3, "contentEditable", "dblclick", "keydown", "blur", 4, "ngIf", "ngIfElse"], ["mainLabel", ""], ["tabindex", "-1", 1, "label-edit-mode", "chip-text-editable", 3, "contentEditable", "dblclick", "keydown", "blur"], [1, "sub-label", "chip-text-content"], ["class", "sub-label-edit-mode chip-text-editable", 3, "tabindex", "contentEditable", "dblclick", "keydown", "blur", 4, "ngIf", "ngIfElse"], ["subLabelTemplate", ""], [1, "sub-label-edit-mode", "chip-text-editable", 3, "tabindex", "contentEditable", "dblclick", "keydown", "blur"], ["tabindex", "-1", "aria-hidden", "true", 1, "close-icon", 3, "click", "keydown", "focus", "blur"], ["viewBox", "0 0 16 16", "fill", "none", "xmlns", "http://www.w3.org/2000/svg"], ["fill-rule", "evenodd", "clip-rule", "evenodd", "d", "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.0402 4.04022C4.35262 3.7278 4.85915 3.7278 5.17157 4.04022L7.99999 6.86864L10.8284 4.04021C11.1408 3.72779 11.6474 3.72779 11.9598 4.04021C12.2722 4.35263 12.2722 4.85916 11.9598 5.17158L9.13136 8.00001L11.9598 10.8284C12.2722 11.1409 12.2722 11.6474 11.9598 11.9598C11.6474 12.2722 11.1408 12.2722 10.8284 11.9598L7.99999 9.13138L5.17158 11.9598C4.85916 12.2722 4.35262 12.2722 4.0402 11.9598C3.72779 11.6474 3.72779 11.1409 4.0402 10.8284L6.86862 8.00001L4.0402 5.17159C3.72778 4.85917 3.72778 4.35264 4.0402 4.04022Z", "fill", "none"]],
      template: function ChipComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵlistener("keydown", function ChipComponent_Template_div_keydown_0_listener($event) {
            return ctx.onChipKeydown($event);
          })("click", function ChipComponent_Template_div_click_0_listener($event) {
            return ctx.onChipClick($event);
          });
          i0.ɵɵelementStart(1, "div");
          i0.ɵɵtemplate(2, ChipComponent_div_2_Template, 2, 1, "div", 1)(3, ChipComponent_span_3_Template, 4, 2, "span", 2)(4, ChipComponent_span_4_Template, 4, 2, "span", 3)(5, ChipComponent_button_5_Template, 3, 1, "button", 4);
          i0.ɵɵelementEnd()();
        }
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.getClass());
          i0.ɵɵproperty("id", ctx.id)("tabindex", ctx.chipTabIndex);
          i0.ɵɵadvance();
          i0.ɵɵclassMap(ctx.getClass());
          i0.ɵɵclassProp("error", ctx.errorState);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.icon);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.label || ctx.labelEditable);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.subLabel || ctx.subLabelEditable);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.allowClose);
        }
      },
      dependencies: [i2.NgIf, i2.NgTemplateOutlet],
      styles: [".sol-chip{box-sizing:border-box;display:inline-flex;width:fit-content;border:none;overflow:auto}.sol-chip:focus-visible{outline:var(--color-globalstate-focus) solid 1px}.sol-chip>div{box-sizing:border-box;border-width:1px;border-style:solid;display:flex;justify-content:center;align-items:center}.sol-chip>div .chip-text-content{white-space:nowrap}.sol-chip>div .chip-text-content .chip-text-editable{display:inline-block;min-width:.25rem;cursor:pointer}.sol-chip>div .chip-text-content .chip-text-editable[contenteditable]{outline:none}.sol-chip>div .close-icon{cursor:pointer;appearance:none;border:none;background:none;padding:0}.sol-chip>div .close-icon,.sol-chip>div .icon{display:flex;justify-content:center;align-items:center;border-radius:50%}.sol-chip>div .close-icon:focus-visible,.sol-chip>div .icon:focus-visible{outline-style:solid;outline-width:1px}.sol-chip>.primary.large{height:2.25rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.5rem;background-color:var(--color-interface-blue450);border-color:transparent;color:#fff}.sol-chip>.primary.large:hover,.sol-chip>.primary.large:active{background-color:var(--color-interface-blue550)}.sol-chip>.primary.large .close-icon,.sol-chip>.primary.large .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.large .close-icon svg,.sol-chip>.primary.large .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.primary.large .close-icon path,.sol-chip>.primary.large .icon path{fill:var(--color-interface-background125)}.sol-chip>.primary.large .close-icon:active path,.sol-chip>.primary.large .icon:active path{fill:#fff}.sol-chip>.primary.large.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.primary.large.error:hover,.sol-chip>.primary.large.error:active{background-color:#fdf0f1}.sol-chip>.primary.large.error .icon{outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.large.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.primary.large.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.primary.large.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.primary.large.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.primary.large.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip>.primary.medium{height:1.75rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.375rem;background-color:var(--color-interface-blue450);border-color:transparent;color:#fff}.sol-chip>.primary.medium:hover,.sol-chip>.primary.medium:active{background-color:var(--color-interface-blue550)}.sol-chip>.primary.medium .close-icon,.sol-chip>.primary.medium .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.medium .close-icon svg,.sol-chip>.primary.medium .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.primary.medium .close-icon path,.sol-chip>.primary.medium .icon path{fill:var(--color-interface-background125)}.sol-chip>.primary.medium .close-icon:active path,.sol-chip>.primary.medium .icon:active path{fill:#fff}.sol-chip>.primary.medium.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.primary.medium.error:hover,.sol-chip>.primary.medium.error:active{background-color:#fdf0f1}.sol-chip>.primary.medium.error .icon{outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.medium.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.primary.medium.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.primary.medium.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.primary.medium.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.primary.medium.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip>.primary.small{height:1.25rem;border-radius:.25rem;outline-offset:.125rem;padding:0 .375rem;gap:.25rem;background-color:var(--color-interface-blue450);border-color:transparent;color:#fff}.sol-chip>.primary.small:hover,.sol-chip>.primary.small:active{background-color:var(--color-interface-blue550)}.sol-chip>.primary.small .close-icon,.sol-chip>.primary.small .icon{height:.75rem;min-width:.75rem;width:.75rem;outline-offset:.125rem;outline-color:#fff}.sol-chip>.primary.small .close-icon svg,.sol-chip>.primary.small .icon svg{height:.75rem;min-width:.75rem;width:.75rem}.sol-chip>.primary.small .close-icon path,.sol-chip>.primary.small .icon path{fill:var(--color-interface-background125)}.sol-chip>.primary.small .close-icon:active path,.sol-chip>.primary.small .icon:active path{fill:#fff}.sol-chip>.primary.small.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.primary.small.error:hover,.sol-chip>.primary.small.error:active{background-color:#fdf0f1}.sol-chip>.primary.small.error .icon{outline-offset:.125rem;outline-color:#fff}.sol-chip>.primary.small.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.primary.small.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.primary.small.error .close-icon{outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.primary.small.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.primary.small.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip.large{outline-offset:.187rem;border-radius:.25rem}.sol-chip>.basic.large{height:2.25rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.5rem;background-color:#fff;border-color:var(--color-globalstate-active-border);color:var(--color-interface-text700)}.sol-chip>.basic.large:hover,.sol-chip>.basic.large:active{background-color:var(--color-interface-background100)}.sol-chip>.basic.large .close-icon,.sol-chip>.basic.large .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.large .close-icon svg,.sol-chip>.basic.large .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.basic.large .close-icon path,.sol-chip>.basic.large .icon path{fill:var(--color-interface-text450)}.sol-chip>.basic.large .close-icon:active path,.sol-chip>.basic.large .icon:active path{fill:var(--color-interface-text700)}.sol-chip>.basic.large.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.basic.large.error:hover,.sol-chip>.basic.large.error:active{background-color:#fdf0f1}.sol-chip>.basic.large.error .icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.large.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.basic.large.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.basic.large.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.large.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.basic.large.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip.medium{outline-offset:.187rem;border-radius:.25rem}.sol-chip>.basic.medium{height:1.75rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.375rem;background-color:#fff;border-color:var(--color-globalstate-active-border);color:var(--color-interface-text700)}.sol-chip>.basic.medium:hover,.sol-chip>.basic.medium:active{background-color:var(--color-interface-background100)}.sol-chip>.basic.medium .close-icon,.sol-chip>.basic.medium .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.medium .close-icon svg,.sol-chip>.basic.medium .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.basic.medium .close-icon path,.sol-chip>.basic.medium .icon path{fill:var(--color-interface-text450)}.sol-chip>.basic.medium .close-icon:active path,.sol-chip>.basic.medium .icon:active path{fill:var(--color-interface-text700)}.sol-chip>.basic.medium.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.basic.medium.error:hover,.sol-chip>.basic.medium.error:active{background-color:#fdf0f1}.sol-chip>.basic.medium.error .icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.medium.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.basic.medium.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.basic.medium.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.medium.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.basic.medium.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip.small{outline-offset:.125rem;border-radius:.25rem}.sol-chip>.basic.small{height:1.25rem;border-radius:.25rem;outline-offset:.125rem;padding:0 .375rem;gap:.25rem;background-color:#fff;border-color:var(--color-globalstate-active-border);color:var(--color-interface-text700)}.sol-chip>.basic.small:hover,.sol-chip>.basic.small:active{background-color:var(--color-interface-background100)}.sol-chip>.basic.small .close-icon,.sol-chip>.basic.small .icon{height:.75rem;min-width:.75rem;width:.75rem;outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.small .close-icon svg,.sol-chip>.basic.small .icon svg{height:.75rem;min-width:.75rem;width:.75rem}.sol-chip>.basic.small .close-icon path,.sol-chip>.basic.small .icon path{fill:var(--color-interface-text450)}.sol-chip>.basic.small .close-icon:active path,.sol-chip>.basic.small .icon:active path{fill:var(--color-interface-text700)}.sol-chip>.basic.small.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.basic.small.error:hover,.sol-chip>.basic.small.error:active{background-color:#fdf0f1}.sol-chip>.basic.small.error .icon{outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.small.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.basic.small.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.basic.small.error .close-icon{outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.small.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.basic.small.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip .small .main-label{font-family:var(--typography-opensans-body-buttonsmall-font-family);font-style:var(--typography-opensans-body-buttonsmall-font-style);font-weight:var(--typography-opensans-body-buttonsmall-font-weight);font-size:var(--typography-opensans-body-buttonsmall-font-size);line-height:var(--typography-opensans-body-buttonsmall-line-height)}.sol-chip .small .sub-label{font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);font-size:var(--typography-opensans-body-body4-font-size);line-height:var(--typography-opensans-body-body4-line-height)}.sol-chip .medium .main-label,.sol-chip .large .main-label{font-family:var(--typography-opensans-body-buttonnormal-font-family);font-style:var(--typography-opensans-body-buttonnormal-font-style);font-weight:var(--typography-opensans-body-buttonnormal-font-weight);font-size:var(--typography-opensans-body-buttonnormal-font-size);line-height:var(--typography-opensans-body-buttonnormal-line-height)}.sol-chip .medium .sub-label,.sol-chip .large .sub-label{font-family:var(--typography-opensans-body-body3-font-family);font-style:var(--typography-opensans-body-body3-font-style);font-weight:var(--typography-opensans-body-body3-font-weight);font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-body-body3-line-height)}\n"],
      encapsulation: 2,
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipComponent, [{
    type: Component,
    args: [{
      selector: 'sol-chip',
      changeDetection: ChangeDetectionStrategy.OnPush,
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"sol-chip\" [id]=\"id\" [class]=\"getClass()\" [tabindex]=\"chipTabIndex\" (keydown)=\"onChipKeydown($event)\" (click)=\"onChipClick($event)\">\n  <div [class]=\"getClass()\" [class.error]=\"errorState\">\n    <div class=\"icon\" *ngIf=\"icon\">\n      <ng-template [ngTemplateOutlet]=\"icon\"></ng-template>\n    </div>\n    <span *ngIf=\"label || labelEditable\" class=\"main-label chip-text-content\">\n      <span\n        *ngIf=\"labelEditable; else mainLabel\"\n        tabindex=\"-1\"\n        class=\"label-edit-mode chip-text-editable\"\n        [contentEditable]=\"labelEditState\"\n        (dblclick)=\"setLabelEditable()\"\n        (keydown)=\"onMainLabelKeydown($event)\"\n        (blur)=\"onMainLabelBlur()\"\n      >\n        {{ label }}\n      </span>\n      <ng-template #mainLabel>{{ label }}</ng-template>\n    </span>\n    <span *ngIf=\"subLabel || subLabelEditable\" class=\"sub-label chip-text-content\">\n      <span\n        *ngIf=\"subLabelEditable; else subLabelTemplate\"\n        [tabindex]=\"-1\"\n        class=\"sub-label-edit-mode chip-text-editable\"\n        [contentEditable]=\"subLabelEditState\"\n        (dblclick)=\"setSubLabelEditable()\"\n        (keydown)=\"onSubLabelKeydown($event)\"\n        (blur)=\"onSubLabelBlur()\"\n      >\n        {{ subLabel }}\n      </span>\n      <ng-template #subLabelTemplate>{{ subLabel }}</ng-template>\n    </span>\n    <button\n      *ngIf=\"allowClose\"\n      class=\"close-icon\"\n      (click)=\"onClose($event)\"\n      tabindex=\"-1\"\n      (keydown)=\"onCloseButtonKeydown($event)\"\n      (focus)=\"onCloseIconFocus()\"\n      (blur)=\"onCloseIconBlur()\"\n      aria-hidden=\"true\"\n      [attr.aria-label]=\"closeIconAriaLabel\"\n    >\n      <svg viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n        <path\n          fill-rule=\"evenodd\"\n          clip-rule=\"evenodd\"\n          d=\"M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM4.0402 4.04022C4.35262 3.7278 4.85915 3.7278 5.17157 4.04022L7.99999 6.86864L10.8284 4.04021C11.1408 3.72779 11.6474 3.72779 11.9598 4.04021C12.2722 4.35263 12.2722 4.85916 11.9598 5.17158L9.13136 8.00001L11.9598 10.8284C12.2722 11.1409 12.2722 11.6474 11.9598 11.9598C11.6474 12.2722 11.1408 12.2722 10.8284 11.9598L7.99999 9.13138L5.17158 11.9598C4.85916 12.2722 4.35262 12.2722 4.0402 11.9598C3.72779 11.6474 3.72779 11.1409 4.0402 10.8284L6.86862 8.00001L4.0402 5.17159C3.72778 4.85917 3.72778 4.35264 4.0402 4.04022Z\"\n          fill=\"none\"\n        />\n      </svg>\n    </button>\n  </div>\n</div>\n",
      styles: [".sol-chip{box-sizing:border-box;display:inline-flex;width:fit-content;border:none;overflow:auto}.sol-chip:focus-visible{outline:var(--color-globalstate-focus) solid 1px}.sol-chip>div{box-sizing:border-box;border-width:1px;border-style:solid;display:flex;justify-content:center;align-items:center}.sol-chip>div .chip-text-content{white-space:nowrap}.sol-chip>div .chip-text-content .chip-text-editable{display:inline-block;min-width:.25rem;cursor:pointer}.sol-chip>div .chip-text-content .chip-text-editable[contenteditable]{outline:none}.sol-chip>div .close-icon{cursor:pointer;appearance:none;border:none;background:none;padding:0}.sol-chip>div .close-icon,.sol-chip>div .icon{display:flex;justify-content:center;align-items:center;border-radius:50%}.sol-chip>div .close-icon:focus-visible,.sol-chip>div .icon:focus-visible{outline-style:solid;outline-width:1px}.sol-chip>.primary.large{height:2.25rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.5rem;background-color:var(--color-interface-blue450);border-color:transparent;color:#fff}.sol-chip>.primary.large:hover,.sol-chip>.primary.large:active{background-color:var(--color-interface-blue550)}.sol-chip>.primary.large .close-icon,.sol-chip>.primary.large .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.large .close-icon svg,.sol-chip>.primary.large .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.primary.large .close-icon path,.sol-chip>.primary.large .icon path{fill:var(--color-interface-background125)}.sol-chip>.primary.large .close-icon:active path,.sol-chip>.primary.large .icon:active path{fill:#fff}.sol-chip>.primary.large.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.primary.large.error:hover,.sol-chip>.primary.large.error:active{background-color:#fdf0f1}.sol-chip>.primary.large.error .icon{outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.large.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.primary.large.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.primary.large.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.primary.large.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.primary.large.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip>.primary.medium{height:1.75rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.375rem;background-color:var(--color-interface-blue450);border-color:transparent;color:#fff}.sol-chip>.primary.medium:hover,.sol-chip>.primary.medium:active{background-color:var(--color-interface-blue550)}.sol-chip>.primary.medium .close-icon,.sol-chip>.primary.medium .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.medium .close-icon svg,.sol-chip>.primary.medium .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.primary.medium .close-icon path,.sol-chip>.primary.medium .icon path{fill:var(--color-interface-background125)}.sol-chip>.primary.medium .close-icon:active path,.sol-chip>.primary.medium .icon:active path{fill:#fff}.sol-chip>.primary.medium.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.primary.medium.error:hover,.sol-chip>.primary.medium.error:active{background-color:#fdf0f1}.sol-chip>.primary.medium.error .icon{outline-offset:.187rem;outline-color:#fff}.sol-chip>.primary.medium.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.primary.medium.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.primary.medium.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.primary.medium.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.primary.medium.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip>.primary.small{height:1.25rem;border-radius:.25rem;outline-offset:.125rem;padding:0 .375rem;gap:.25rem;background-color:var(--color-interface-blue450);border-color:transparent;color:#fff}.sol-chip>.primary.small:hover,.sol-chip>.primary.small:active{background-color:var(--color-interface-blue550)}.sol-chip>.primary.small .close-icon,.sol-chip>.primary.small .icon{height:.75rem;min-width:.75rem;width:.75rem;outline-offset:.125rem;outline-color:#fff}.sol-chip>.primary.small .close-icon svg,.sol-chip>.primary.small .icon svg{height:.75rem;min-width:.75rem;width:.75rem}.sol-chip>.primary.small .close-icon path,.sol-chip>.primary.small .icon path{fill:var(--color-interface-background125)}.sol-chip>.primary.small .close-icon:active path,.sol-chip>.primary.small .icon:active path{fill:#fff}.sol-chip>.primary.small.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.primary.small.error:hover,.sol-chip>.primary.small.error:active{background-color:#fdf0f1}.sol-chip>.primary.small.error .icon{outline-offset:.125rem;outline-color:#fff}.sol-chip>.primary.small.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.primary.small.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.primary.small.error .close-icon{outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.primary.small.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.primary.small.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip.large{outline-offset:.187rem;border-radius:.25rem}.sol-chip>.basic.large{height:2.25rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.5rem;background-color:#fff;border-color:var(--color-globalstate-active-border);color:var(--color-interface-text700)}.sol-chip>.basic.large:hover,.sol-chip>.basic.large:active{background-color:var(--color-interface-background100)}.sol-chip>.basic.large .close-icon,.sol-chip>.basic.large .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.large .close-icon svg,.sol-chip>.basic.large .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.basic.large .close-icon path,.sol-chip>.basic.large .icon path{fill:var(--color-interface-text450)}.sol-chip>.basic.large .close-icon:active path,.sol-chip>.basic.large .icon:active path{fill:var(--color-interface-text700)}.sol-chip>.basic.large.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.basic.large.error:hover,.sol-chip>.basic.large.error:active{background-color:#fdf0f1}.sol-chip>.basic.large.error .icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.large.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.basic.large.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.basic.large.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.large.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.basic.large.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip.medium{outline-offset:.187rem;border-radius:.25rem}.sol-chip>.basic.medium{height:1.75rem;border-radius:.25rem;outline-offset:.187rem;padding:0 .5rem;gap:.375rem;background-color:#fff;border-color:var(--color-globalstate-active-border);color:var(--color-interface-text700)}.sol-chip>.basic.medium:hover,.sol-chip>.basic.medium:active{background-color:var(--color-interface-background100)}.sol-chip>.basic.medium .close-icon,.sol-chip>.basic.medium .icon{height:1rem;min-width:1rem;width:1rem;outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.medium .close-icon svg,.sol-chip>.basic.medium .icon svg{height:1rem;min-width:1rem;width:1rem}.sol-chip>.basic.medium .close-icon path,.sol-chip>.basic.medium .icon path{fill:var(--color-interface-text450)}.sol-chip>.basic.medium .close-icon:active path,.sol-chip>.basic.medium .icon:active path{fill:var(--color-interface-text700)}.sol-chip>.basic.medium.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.basic.medium.error:hover,.sol-chip>.basic.medium.error:active{background-color:#fdf0f1}.sol-chip>.basic.medium.error .icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.medium.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.basic.medium.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.basic.medium.error .close-icon{outline-offset:.187rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.medium.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.basic.medium.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip.small{outline-offset:.125rem;border-radius:.25rem}.sol-chip>.basic.small{height:1.25rem;border-radius:.25rem;outline-offset:.125rem;padding:0 .375rem;gap:.25rem;background-color:#fff;border-color:var(--color-globalstate-active-border);color:var(--color-interface-text700)}.sol-chip>.basic.small:hover,.sol-chip>.basic.small:active{background-color:var(--color-interface-background100)}.sol-chip>.basic.small .close-icon,.sol-chip>.basic.small .icon{height:.75rem;min-width:.75rem;width:.75rem;outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.small .close-icon svg,.sol-chip>.basic.small .icon svg{height:.75rem;min-width:.75rem;width:.75rem}.sol-chip>.basic.small .close-icon path,.sol-chip>.basic.small .icon path{fill:var(--color-interface-text450)}.sol-chip>.basic.small .close-icon:active path,.sol-chip>.basic.small .icon:active path{fill:var(--color-interface-text700)}.sol-chip>.basic.small.error{color:var(--color-interface-error600);background-color:#fdf0f1;border-color:var(--color-interface-error500)}.sol-chip>.basic.small.error:hover,.sol-chip>.basic.small.error:active{background-color:#fdf0f1}.sol-chip>.basic.small.error .icon{outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.small.error .icon path{fill:var(--color-interface-error600)}.sol-chip>.basic.small.error .icon:active path{fill:var(--color-interface-error600)}.sol-chip>.basic.small.error .close-icon{outline-offset:.125rem;outline-color:var(--color-globalstate-focus)}.sol-chip>.basic.small.error .close-icon path{fill:var(--color-interface-text700)}.sol-chip>.basic.small.error .close-icon:active path{fill:var(--color-interface-text700)}.sol-chip .small .main-label{font-family:var(--typography-opensans-body-buttonsmall-font-family);font-style:var(--typography-opensans-body-buttonsmall-font-style);font-weight:var(--typography-opensans-body-buttonsmall-font-weight);font-size:var(--typography-opensans-body-buttonsmall-font-size);line-height:var(--typography-opensans-body-buttonsmall-line-height)}.sol-chip .small .sub-label{font-family:var(--typography-opensans-body-body4-font-family);font-style:var(--typography-opensans-body-body4-font-style);font-weight:var(--typography-opensans-body-body4-font-weight);font-size:var(--typography-opensans-body-body4-font-size);line-height:var(--typography-opensans-body-body4-line-height)}.sol-chip .medium .main-label,.sol-chip .large .main-label{font-family:var(--typography-opensans-body-buttonnormal-font-family);font-style:var(--typography-opensans-body-buttonnormal-font-style);font-weight:var(--typography-opensans-body-buttonnormal-font-weight);font-size:var(--typography-opensans-body-buttonnormal-font-size);line-height:var(--typography-opensans-body-buttonnormal-line-height)}.sol-chip .medium .sub-label,.sol-chip .large .sub-label{font-family:var(--typography-opensans-body-body3-font-family);font-style:var(--typography-opensans-body-body3-font-style);font-weight:var(--typography-opensans-body-body3-font-weight);font-size:var(--typography-opensans-body-body3-font-size);line-height:var(--typography-opensans-body-body3-line-height)}\n"]
    }]
  }], () => [{
    type: i1.TranslationService
  }, {
    type: i0.ElementRef
  }, {
    type: i0.ChangeDetectorRef
  }, {
    type: i0.Renderer2
  }], {
    id: [{
      type: Input
    }],
    allowClose: [{
      type: Input
    }],
    labelEditable: [{
      type: Input
    }],
    subLabelEditable: [{
      type: Input
    }],
    chipTabIndex: [{
      type: Input
    }],
    chipRole: [{
      type: Input
    }],
    errorState: [{
      type: Input
    }],
    variant: [{
      type: Input
    }],
    size: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    subLabel: [{
      type: Input
    }],
    icon: [{
      type: Input
    }],
    closeIconAriaLabel: [{
      type: Input
    }],
    closed: [{
      type: Output
    }],
    chipClicked: [{
      type: Output
    }],
    closeButtonKeydown: [{
      type: Output
    }],
    chipKeydown: [{
      type: Output
    }],
    labelChanged: [{
      type: Output
    }],
    subLabelChanged: [{
      type: Output
    }]
  });
})();
class ChipModule {
  static {
    this.ɵfac = function ChipModule_Factory(t) {
      return new (t || ChipModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: ChipModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ChipModule, [{
    type: NgModule,
    args: [{
      declarations: [ChipComponent],
      imports: [CommonModule],
      exports: [ChipComponent]
    }]
  }], null, null);
})();

/*
 * Public API Surface of chip
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ChipComponent, ChipEvent, ChipModule };
